import { DatePipe, Location } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subscription, filter, firstValueFrom, skip } from 'rxjs';
import { CommonServiceService } from 'src/app/Services/common-service.service';
import { CustomToastsService } from 'src/app/Services/custom-toasts.service';
import { onUserLogout } from 'src/app/Services/datadog-session';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { ContainerStatus, ContainerType } from 'src/app/enum/enum';
import { environment } from 'src/app/environments/environment';

import {
  LicensePlates,
  LoginModel,
  MainDepartment,
  ProductionOverride,
  Stations,
  Stores,
  WarehouseLocationsModels,
  WarehouseModel,
  loggedInUserDetailsModel
} from '../../../Models/ApplicationModels';
import { BreadcrumbService } from '../../../Services/breadcrumb.service';
import { GoogleTranslateService } from '../../../Services/google-translate.service';
import { MasterDataSeriveService } from '../../../Services/master-data-serive.service';
import { SessionTimeoutService } from '../../../Services/session-timeout.service';
import { DynamicTranslationService } from '../../../dynamic-translation.service';
import { TranslationCommunicationServiceService } from '../../../translation-communication-service.service';
import { TranslationService } from '../../../translation.service';
import { ProductionCycleSchedule } from '../../admin-module/company-config/WeekColors/models/week-color.model';
import { WeekColorService } from '../../admin-module/company-config/WeekColors/services/week-color.service';
import { containerResponse } from '../../admin-module/inventory-management/Container/Model/Container';
import { ContainersService } from '../../admin-module/inventory-management/Container/Service/containers.service';
import { OverrideState, ProductionOverrideComponent } from '../production-override/production-override.component';

interface BootstrapModal {
  show(): void;
  hide(): void;
}

declare var bootstrap: {
  Modal: new (element: HTMLElement, options?: { backdrop?: string | boolean; keyboard?: boolean }) => BootstrapModal;
};

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  private readonly loginTimeSessionStartKey = 'productionLoginTimeSessionStart';
  private readonly loginTimeInitialHoursKey = 'productionLoginTimeInitialHours';
  private readonly sessionDateKey = 'productionLoginTimeSessionDate';
  @ViewChild('selectWarehouseLocationModal')
  selectWarehouseLocationModal!: ElementRef;
  @ViewChild('closeModal') closeModal!: ElementRef;
  @ViewChild('prodOverride') prodOverride!: ProductionOverrideComponent;

  private languageChangeSubscription: Subscription = new Subscription();
  public enableUnloadConfirmation: boolean = false;
  public tempSelectedStore: number = 0;
  public selectedStoreName: string = '';
  singleTranslatedString: string = '';

  // Basic UI properties
  title: string = 'Choose Department';
  weekcolors: Array<ProductionCycleSchedule> = [];
  stores: Array<Stores> = [];

  // User and authentication
  loggedInUserDataobj: loggedInUserDetailsModel = new loggedInUserDetailsModel();
  currentLanguage = 'English';
  selectedLanguage = 'en';
  translatedTexts: string[] = [];
  translatedTitle: string = '';
  translatedLangName: string = '';
  weekColorsToTranslate: any[] = [];
  userdata: any;
  userInfo: LoginModel = new LoginModel();

  // Date and display
  currentDate: Date = new Date();
  formattedDate: string | null;

  // Breadcrumb properties
  activeDeptTab: string = '';
  activeCategoryTab: string = '';
  activeSubCategoryTab: string = '';
  isDept: boolean = true;
  isCategory: boolean = true;
  isSubCategory: boolean = true;
  isActiveWares: boolean = false;
  handleColor: string = '#175f91';
  isItemEntry: boolean = false;
  isNotOninit: boolean = true;

  // Store and location
  defaultStore: number = 0;
  defaultStoreName: string = '';
  currentStore: string = '';
  color: string = '#175f91;';
  companyName: string = '';
  companyId: number = 0;

  // UI state
  perDayItemEnteries: number = 0;
  showItemEntery: boolean = false;
  activeLanguage: string = 'English';
  isDropdownOpen: boolean = false;
  stationName: string = '';
  isProductionUser: boolean = false;

  // Week color
  selectedcolor: string = '';
  selectedBgColorCurWeek: string = '';
  showWeekColor: boolean = true;

  // Override state (from child component)
  isOverride: boolean = false;
  overrideDetails: OverrideState = { isActive: false };
  isLicensePlateAssigned: boolean = false;
  licensePlateCount: number = 0;

  // Login time
  loginTime: string = '';
  private loginTimeInterval: any;
  private sessionStartTime = 0;
  private initialTodaysTotalHoursLoggedIn = 0;
  private excludedProductionTimeMs = 0;
  private excludedProductionTimeStart: number | null = null;

  // Scan license plate
  scanLicensePlateTerm: string = '';
  scanLicensePlateResults: LicensePlates[] = [];
  scanSearchAttempted: boolean = false;
  isScanningLicensePlate: boolean = false;

  // Scan production bin
  scanProductionBinTerm: string = '';
  scanProductionBinResults: containerResponse[] = [];
  isScanningProductionBin: boolean = false;
  sourceBinName: string = '';
  isLPScanRequired: boolean = false;
  scanLPModalInstance?: BootstrapModal;
  confirmModalInstance?: BootstrapModal;

  availableLanguages = [
    {
      code: 'en',
      name: 'EN',
      fullName: 'English',
      url: '../../assets/languages/engUs.svg',
      isPrimary: true
    },
    {
      code: 'es',
      name: 'ES',
      fullName: 'Spanish',
      url: '../../assets/languages/spanish.svg',
      isPrimary: false
    },
    {
      code: 'fr',
      name: 'FR',
      fullName: 'French',
      url: '../../assets/languages/french.svg',
      isPrimary: false
    },
    {
      code: 'de',
      name: 'DE ',
      fullName: 'German',
      url: '../../assets/languages/german.svg',
      isPrimary: false
    },
    {
      code: 'it',
      name: 'IT',
      fullName: 'Italian',
      url: '../../assets/languages/itallian.svg',
      isPrimary: false
    }
  ];

  constructor(
    private userService: UserserviceService,
    private mservice: MasterDataSeriveService,
    private router: Router,
    private location: Location,
    private translationService: TranslationService,
    private dynamicTranslationService: DynamicTranslationService,
    private translationCommunicationService: TranslationCommunicationServiceService,
    private datePipe: DatePipe,
    private breadcrumbService: BreadcrumbService,
    private toastr: CustomToastsService,
    private commonService: CommonServiceService,
    private cookie: CookieService,
    private weekColorService: WeekColorService,
    private googleTranslateService: GoogleTranslateService,
    private containersService: ContainersService,
    private sessionTimeoutService: SessionTimeoutService
  ) {
    this.formattedDate = this.datePipe.transform(this.currentDate, 'dd MMM yy');
  }

  async ngOnInit() {
    this.userInfo = this.mservice.getUserDetailsFromStorage();
    this.isProductionUser = this.userInfo.defaultModuleID == 2 ? true : false;
    this.selectedcolor = this.userInfo.productionCycle;
    this.selectedBgColorCurWeek = this.userInfo.productionCycleColor;
    this.showWeekColor = this.userInfo?.productionScheduleType !== 'DateSpecific';

    this.initializeLoginTimeTracking();

    this.updateLoginTime();

    // Update login time every minute (local calculation only)
    this.loginTimeInterval = setInterval(() => {
      this.checkDayRollover();
      this.updateLoginTime();
    }, 60000); // Update every 60 seconds (1 minute)

    // Load override state from localStorage
    this.isOverride = localStorage.getItem('isOverride') === 'true';
    const storedDetails = localStorage.getItem('overrideDetails');
    if (storedDetails) {
      this.overrideDetails = JSON.parse(storedDetails);
    }
    this.isLicensePlateAssigned = !!(this.isOverride || this.overrideDetails.licensePlateId);
    this.hydrateOverrideWeekColor();

    this.setBreadCrumb();
    this.initializeData();
    localStorage.removeItem('isNavigatingBack');

    this.breadcrumbService.updatePerDaytEnteries(false);
    this.breadcrumbService.totalItemEnterisPerDay$.subscribe(enteries => {
      this.perDayItemEnteries = enteries;
    });

    this.userdata = this.mservice.getUserDetailsFromStorage();
    this.companyName = this.userdata.company;
    this.companyId = this.userdata.companyID;

    await this.getStores();
    this.getStationName();

    const langSub = this.translationCommunicationService.getSelectedLanguage().subscribe(language => {
      this.selectedLanguage = language;
      this.availableLanguages.forEach(ele => {
        ele.isPrimary = false;
        if (ele.code == language) {
          this.activeLanguage = ele.fullName;
          ele.isPrimary = true;
        }
      });

      this.translationService.setNavMenuLanguage(language);
      this.dynamicTranslationService.setNavMenuLanguage(language);
      this.googleTranslateService.changeLanguage(language);

      if (language === 'en') {
        this.currentLanguage = 'English';
      } else if (language === 'es') {
        this.currentLanguage = 'Spanish';
      } else if (language === 'fr') {
        this.currentLanguage = 'French';
      } else if (language === 'de') {
        this.currentLanguage = 'German';
      } else if (language === 'it') {
        this.currentLanguage = 'Italian';
      }
      this.translateText(this.title);
      this.translateText(this.currentLanguage);
    });
    this.languageChangeSubscription.add(langSub);

    const routerSub = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.googleTranslateService.changeLanguage(this.selectedLanguage);
    });
    this.languageChangeSubscription.add(routerSub);

    // Load license plate count if a license plate is assigned
    if (this.isLicensePlateAssigned && this.overrideDetails.licensePlateId) {
      const cached = localStorage.getItem(`licensePlateCount_${this.overrideDetails.licensePlateId}`);
      this.licensePlateCount = cached ? parseInt(cached, 10) : 0;
    }

    const binName = localStorage.getItem('ProductionBin');

    if (binName) {
      this.sourceBinName = binName;
    }

    this.checkAndShowLPModal();
    window.addEventListener('licensePlateCountUpdated', this.onLicensePlateCountUpdated as EventListener);
  }

  ngOnDestroy() {
    this.languageChangeSubscription.unsubscribe();
    if (this.loginTimeInterval) {
      clearInterval(this.loginTimeInterval);
    }
    this.sessionTimeoutService.stopHeartbeatTimer();
    window.removeEventListener('licensePlateCountUpdated', this.onLicensePlateCountUpdated as EventListener);
  }

  onLicensePlateCountUpdated = (e: any) => {
    try {
      const detail = e?.detail;
      if (!detail) return;
      if (this.overrideDetails?.licensePlateId == detail.licensePlateId) {
        this.licensePlateCount = detail.count;
      }
    } catch (err) {}
  };

  async initializeData() {
    const result = await this.commonService.getWeekColorCycle();
    if (result) {
      this.selectedcolor = result.displayName;
      this.selectedBgColorCurWeek = result.color;
    }
  }

  setBreadCrumb() {
    this.breadcrumbService.activeDeptTab$.subscribe(activeDepttab => {
      this.activeDeptTab = activeDepttab;
      if (this.activeDeptTab == '') {
        this.isNotOninit = false;
        this.isDept = false;
        this.isCategory = false;
        this.isSubCategory = false;
        localStorage.setItem('isNavigatingBack', 'true');
        localStorage.setItem('isNavigatingBacktoMainDept', 'true');
      } else if (this.activeDeptTab == 'Choose Departments') {
        this.color = 'black';
        this.isDept = true;
      } else {
        this.isDept = true;
        this.color = '#0070b9';
      }
    });

    this.breadcrumbService.activeCategoryTab$.subscribe(activeCategoryTab => {
      this.activeCategoryTab = activeCategoryTab;
      this.isSubCategory = false;

      if (this.activeCategoryTab == '') {
        this.isCategory = false;
        localStorage.setItem('isNavigatingBack', 'null');
      } else {
        this.isCategory = true;
        localStorage.setItem('isNavigatingBack', 'true');
      }

      if (
        this.activeCategoryTab == 'Choose Categories' ||
        this.activeCategoryTab == 'History' ||
        this.activeCategoryTab == 'Production Overview' ||
        this.activeCategoryTab == 'Top Performer' ||
        this.activeCategoryTab == 'Move To Floor' ||
        this.activeCategoryTab == 'Bulk Item Entry' ||
        this.activeCategoryTab == 'Scan Pulls' ||
        this.activeCategoryTab == 'AI Chatbot'
      ) {
        const isScanPullScreen = this.activeCategoryTab == 'Scan Pulls';
        this.isNotOninit = false;
        this.handleColor = 'black';
        this.isItemEntry = !isScanPullScreen;
        this.showItemEntery = true;
        if (this.activeCategoryTab == 'Choose Categories') {
          this.showItemEntery = false;
        }
      } else {
        this.handleColor = '#0070b9';
        this.isItemEntry = false;
        this.showItemEntery = false;
      }

      this.updateProductionTimeExclusion();

      const activeUrl = this.location.path();
      if (activeUrl.includes('prod-item')) {
        this.isActiveWares = true;
      } else {
        this.isActiveWares = false;
      }
    });

    this.breadcrumbService.activeSubCategoryTab$.subscribe(activeSubCategoryTab => {
      this.activeSubCategoryTab = activeSubCategoryTab;
      if (this.activeSubCategoryTab == '') {
        this.isSubCategory = false;
        localStorage.setItem('isNavigatingBack', 'null');
      } else {
        this.isSubCategory = true;
        localStorage.setItem('isNavigatingBack', 'true');
      }

      const activeUrl = this.location.path();
      if (activeUrl.includes('prod-item')) {
        this.isActiveWares = true;
      } else {
        this.isActiveWares = false;
      }
    });
  }

  async getStores() {
    let store = localStorage.getItem('tempStoreId') || localStorage.getItem('storeId');
    this.defaultStore = parseInt(store || '0');

    this.commonService.getStores(this.companyId).then(res => {
      this.stores = res as Stores[];
      let store = this.stores.filter(item => item.storeId == this.defaultStore);

      if (!store[0] && this.stores.length > 0) {
        this.defaultStore = this.stores[0].storeId;
        store = [this.stores[0]];
      }

      let tempStoreId = localStorage.getItem('tempStoreId') || localStorage.getItem('storeId');
      this.tempSelectedStore = parseInt(tempStoreId || '0');
      this.defaultStoreName = store[0]?.storeName;
      this.selectedStoreName = this.stores.find(s => s.storeId === this.tempSelectedStore)?.storeName || '';

      const selectedStore = this.stores.find(s => s.storeId === this.tempSelectedStore);
      localStorage.setItem('storeName', selectedStore?.storeName || '');
      localStorage.setItem('StoreCode', JSON.stringify(selectedStore?.storeCode || ''));

      this.setDefaultStoreName(this.defaultStoreName);
      this.setLocation();
      localStorage.setItem('storeGroup', store[0]?.storeGroupId.toString() || '');
    });
  }

  setDefaultStoreName(storeName: string) {
    let store = localStorage.getItem('defaultStoreName') || '';
    if (!store) localStorage.setItem('defaultStoreName', storeName);
  }

  setLocation() {
    const storedLocationId = localStorage.getItem('CurrentLocationID');

    if (!storedLocationId) {
      const defaultLocationId = this.userInfo?.defaultProcessorLocationID;

      if (defaultLocationId && Number(defaultLocationId) > 0) {
        localStorage.setItem('CurrentLocationID', defaultLocationId.toString());
      }
    }
  }

  getStationName() {
    const storedStationName = localStorage.getItem('stationName') || '';
    if (storedStationName) {
      this.stationName = storedStationName;
    }

    this.commonService.getStation().subscribe(res => {
      if (res?.length > 0) {
        this.stationName = res;
        localStorage.setItem('stationName', res);
      }
    });
  }

  navigateToMainDepartment() {
    localStorage.setItem('isNavigatingBack', 'true');
    this.router.navigate(['/production/home/departments']);
  }

  onLanguageChange(languageCode: string): void {
    this.translationCommunicationService.setSelectedLanguage(languageCode);
  }

  // Call this function whenever you want to update the translatedTitle
  updateNavContent(translatedNames: string | string[]): void {
    if (Array.isArray(translatedNames)) {
    } else {
      this.singleTranslatedString = translatedNames;
    }
  }

  translateText(textOrTexts: string | string[]) {
    const textsToTranslate = Array.isArray(textOrTexts) ? textOrTexts : [textOrTexts];

    this.dynamicTranslationService.translateText(textsToTranslate).subscribe((translatedTexts: string[]) => {
      if (Array.isArray(textOrTexts)) {
        this.translatedTexts = translatedTexts;
      } else {
        const translatedString = translatedTexts[0];
        if (textOrTexts === this.title) {
          this.singleTranslatedString = translatedString;
          this.translatedTitle = translatedString; // Set the translated title
        } else if (textOrTexts === this.currentLanguage) {
          this.translatedLangName = translatedString;
        }
      }
    });
  }

  handleDropdownToggle() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  searchLicensePlates() {
    const term = this.scanLicensePlateTerm?.trim();
    if (!term) {
      this.toastr.error('Please scan or enter a license plate');
      return;
    }

    this.isScanningLicensePlate = true;
    this.scanSearchAttempted = true;
    this.scanLicensePlateResults = [];

    const storeId = parseInt(localStorage.getItem('tempStoreId') || localStorage.getItem('storeId') || '0');

    this.mservice.getAllLicensePlates(this.companyId, undefined, term, storeId || undefined).subscribe({
      next: res => {
        const response: any = res as any;
        const items = Array.isArray(response)
          ? (response as LicensePlates[])
          : (response?.items as LicensePlates[]) || [];
        this.scanLicensePlateResults = items;
        if (this.scanLicensePlateResults.length === 0) {
          this.toastr.error('No license plates found');
        }
        this.isScanningLicensePlate = false;
      },
      error: err => {
        const errorMessage = this.commonService.extractErrorMessage(err, 'Failed to search license plates');
        this.toastr.error(errorMessage);
        this.isScanningLicensePlate = false;
      }
    });
  }

  async assignScannedLicensePlate(licensePlate: LicensePlates) {
    if (!this.prodOverride) {
      this.toastr.error('Override component is not available');
      return;
    }

    const overrideId = licensePlate.associationId;

    const [, overrideOutcome] = await Promise.all([
      this.prodOverride.resolveLicensePlateStoreId(licensePlate),
      overrideId
        ? firstValueFrom(this.mservice.getProductionOverrideByOverrideId(overrideId))
            .then(res => ({ res, err: null as any }))
            .catch(err => ({ res: null, err }))
        : Promise.resolve({ res: null, err: null as any })
    ]);

    if (overrideId) {
      const { res, err } = overrideOutcome;
      if (err && err.status !== 404) {
        const errorMessage = this.commonService.extractErrorMessage(err, 'Failed to load override details');
        this.toastr.error(errorMessage);
        return;
      }
      if (res) {
        this.persistOverrideToLocalStorage(res);
      }
      await this.prodOverride.adoptOverride((res as ProductionOverride) || null);
    } else {
      await this.prodOverride.adoptOverride(null);
    }

    this.prodOverride.assignLicensePlateFromScan(licensePlate);
    this.resetScanLicensePlateModal();
    this.hideModalSafely('scanLicensePlateModal');
  }

  resetScanLicensePlateModal() {
    this.scanLicensePlateTerm = '';
    this.scanLicensePlateResults = [];
    this.scanSearchAttempted = false;
    this.isScanningLicensePlate = false;
  }

  private getActiveOverrideId(): number {
    if (this.overrideDetails?.overrideId) {
      return this.overrideDetails.overrideId;
    }

    const overrideDetails = localStorage.getItem('overrideDetails');
    if (overrideDetails) {
      const details = JSON.parse(overrideDetails);
      if (details?.overrideId) {
        return details.overrideId;
      }
    }

    const mainOverrides = localStorage.getItem('MainOverrides');
    if (mainOverrides) {
      const main = JSON.parse(mainOverrides);
      if (main?.id) {
        return main.id;
      }
    }

    return 0;
  }

  private persistOverrideToLocalStorage(override: any): void {
    localStorage.setItem('MainOverrides', JSON.stringify(override));

    const existingDetails = localStorage.getItem('overrideDetails');
    const details = existingDetails ? JSON.parse(existingDetails) : {};
    if (override?.id) {
      details.overrideId = override.id;
    }
    if (override?.description) {
      details.overrideDesc = override.description;
    }
    if (override?.weekColorDate) {
      details.date = override.weekColorDate;
    }
    if (override?.weekColor) {
      details.weekColorName = override.weekColor;
    }

    if (Object.keys(details).length > 0) {
      localStorage.setItem('overrideDetails', JSON.stringify(details));
    }
  }

  getScanLicensePlateLabel(licensePlate: LicensePlates): string {
    return licensePlate.referenceNumber || licensePlate.description || `#${licensePlate.id}`;
  }

  // Handle override state changes from child component
  onOverrideStateChanged(state: OverrideState) {
    this.isOverride = state.isActive;
    this.overrideDetails = state;
    this.isLicensePlateAssigned = !!(state.isActive || state.licensePlateId);
    this.hydrateOverrideWeekColor();

    if (state.licensePlateId) {
      const cached = localStorage.getItem(`licensePlateCount_${state.licensePlateId}`);
      this.licensePlateCount = cached ? parseInt(cached, 10) : 0;
    } else {
      this.licensePlateCount = 0;
    }

    if (!state.isActive) {
      this.checkAndShowLPModal();
    }
  }

  // Handle store changes from child component
  onStoreChanged(storeId: number) {
    this.getStores();
  }

  // Handle refresh needs from child component
  onNeedsRefresh() {
    this.initializeData();
    this.getStores();
  }

  private hydrateOverrideWeekColor(): void {
    if (!this.showWeekColor || !this.isOverride || this.overrideDetails?.weekColor) {
      return;
    }

    const date = this.overrideDetails?.date;
    if (!date) {
      return;
    }

    this.weekColorService.getProductionCycleScheduleByDate(this.companyId, date).subscribe({
      next: res => {
        const wc: any = res as any;
        if (wc?.color) {
          this.overrideDetails = {
            ...this.overrideDetails,
            weekColor: wc.color
          };
          localStorage.setItem('overrideDetails', JSON.stringify(this.overrideDetails));
        }
      },
      error: () => {}
    });
  }

  changeModule() {
    const isBypassLicense = sessionStorage.getItem('isBypassLicense') === 'true';

    if (isBypassLicense) {
      this.router.navigateByUrl('/admin/home/admin-home');
    } else {
      this.commonService.unassignStationLicenseAndContinue(
        res => {
          this.toastr.success(res.message);
          setTimeout(() => {
            this.router.navigateByUrl('/admin/home/admin-home');
          }, 3000);
        },
        () => {
          this.toastr.error('Failed to unassign license');
          setTimeout(() => {
            this.router.navigateByUrl('/admin/home/admin-home');
          }, 3000);
        }
      );
    }
  }

  Logout(): void {
    const domain = environment.domainName;
    const companyweburl = environment.companyWebBaseUrl;
    sessionStorage.setItem('isUserInitiatedLogout', 'true');
    this.enableUnloadConfirmation = false;
    onUserLogout();

    const performLogout = () => {
      this.onLogout();
      localStorage.clear();
      sessionStorage.clear();
      this.cookie.deleteAll('/', domain);
      document.cookie = `logoutEvent=1; domain=${domain}; path=/; max-age=10`;
      this.userService.userPermissions = null;
      this.userService.rolesLoaded = false;
      this.toastr.success('Proceeding to the logout');
      window.location.href = `${companyweburl}/shared/login`;
    };

    const isBypassLicense = sessionStorage.getItem('isBypassLicense') === 'true';

    if (isBypassLicense) {
      performLogout();
    } else {
      this.commonService.unassignStationLicenseAndContinue(performLogout);
    }
  }

  async onLogout(): Promise<void> {
    await this.commonService.logoutCompany(this.userInfo?.userId);
  }

  private async handleStationLicenseChange(): Promise<boolean> {
    const currentStoreId = Number(localStorage.getItem('tempStoreId') || localStorage.getItem('storeId') || '0');
    const isStoreChanging = currentStoreId > 0 && currentStoreId !== this.tempSelectedStore;
    if (!isStoreChanging) {
      return true;
    }

    const isBypassLicense = sessionStorage.getItem('isBypassLicense') === 'true';
    if (!isBypassLicense) {
      try {
        await new Promise<void>((resolve, reject) => {
          this.commonService.unassignStationLicenseAndContinue(
            () => resolve(),
            () => reject()
          );
        });
      } catch {
        this.toastr.error('Failed to unassign existing station license');
        return false;
      }
    }

    sessionStorage.setItem('isFirstVisit', 'true');
    localStorage.removeItem('stationId');
    localStorage.removeItem('stationName');
    return true;
  }

  async selectStore() {
    this.userInfo = this.mservice.getUserDetailsFromStorage();
    const userDefaultStoreId = this.userInfo?.storeId;

    let shouldReload = false;

    if (this.tempSelectedStore === userDefaultStoreId) {
      const currentStore = this.stores.find(store => store.storeId === this.tempSelectedStore);
      this.defaultStore = this.tempSelectedStore;
      this.selectedStoreName = currentStore?.storeName || this.defaultStoreName || '';

      // ensure the previous station license is unassigned first.
      if (!(await this.handleStationLicenseChange())) {
        return;
      }

      localStorage.setItem('tempStoreId', JSON.stringify(this.tempSelectedStore));
      localStorage.setItem('storeId', JSON.stringify(this.tempSelectedStore));

      localStorage.setItem('CurrentLocationID', this.userInfo.defaultProcessorLocationID!.toString());
      localStorage.setItem('storeName', this.selectedStoreName);
      localStorage.setItem('StoreCode', JSON.stringify(currentStore?.storeCode || ''));

      this.toastr.success('You are already on your default store');
      shouldReload = true;
    } else {
      const currentStore = this.stores.find(store => store.storeId === this.tempSelectedStore);
      this.selectedStoreName = currentStore?.storeName || '';

      const selectedWarehouseLocationId = currentStore?.defaultWarehouseLocationId;

      const isValid = await this.validateDefaultLocation(selectedWarehouseLocationId);

      if (!isValid) {
        this.tempSelectedStore = this.defaultStore;
        this.selectedStoreName = this.defaultStoreName;
        this.reloadOrNavigate();
        return;
      }

      if (!(await this.handleStationLicenseChange())) {
        return;
      }

      localStorage.setItem('CurrentLocationID', selectedWarehouseLocationId!.toString());
      localStorage.setItem('tempStoreId', JSON.stringify(this.tempSelectedStore));
      localStorage.setItem('StoreCode', JSON.stringify(currentStore?.storeCode || ''));
      localStorage.setItem('storeName', currentStore?.storeName || '');
      localStorage.setItem('storeGroup', currentStore?.storeGroupId?.toString() || '');

      this.toastr.success('Store and warehouse location updated successfully');
      shouldReload = true;
    }

    if (shouldReload) {
      this.reloadOrNavigate();
    }
  }

  async validateDefaultLocation(locationId?: number): Promise<boolean> {
    await Promise.resolve();

    if (!locationId || locationId <= 0) {
      this.toastr.error('Default warehouse location not set for the selected store');
      return false;
    }

    return true;
  }
  private reloadOrNavigate(): void {
    setTimeout(() => {
      const currentUrl = this.router.url;

      if (currentUrl === '/production/home/departments') {
        window.location.reload();
      } else {
        this.navigateToMainDepartment();
      }
    }, 500);
  }

  private checkDayRollover(): void {
    const todayStr = new Date().toDateString();
    const storedDate = sessionStorage.getItem(this.sessionDateKey);
    if (storedDate && storedDate !== todayStr) {
      sessionStorage.setItem(this.sessionDateKey, todayStr);
      this.sessionStartTime = Date.now();
      this.initialTodaysTotalHoursLoggedIn = 0;
      this.excludedProductionTimeMs = 0;
      this.excludedProductionTimeStart = null;
      sessionStorage.setItem(this.loginTimeSessionStartKey, String(this.sessionStartTime));
      sessionStorage.setItem(this.loginTimeInitialHoursKey, '0');
      localStorage.removeItem('Items');
      localStorage.removeItem('ItemsLastUpdated');
      this.formattedDate = this.datePipe.transform(new Date(), 'dd MMM yy');
      this.breadcrumbService.updatePerDaytEnteries(true);
    }
  }

  private updateLoginTime(): void {
    this.loginTime = this.formatTodaysTotalHoursLoggedIn();
  }

  private initializeLoginTimeTracking(): void {
    const userData = this.mservice.getUserDetailsFromStorage();
    const todayStr = new Date().toDateString();
    const storedDate = sessionStorage.getItem(this.sessionDateKey);

    // If day has changed since last session, clear stale session data
    if (storedDate && storedDate !== todayStr) {
      sessionStorage.removeItem(this.loginTimeSessionStartKey);
      sessionStorage.removeItem(this.loginTimeInitialHoursKey);
      localStorage.removeItem('Items');
      localStorage.removeItem('ItemsLastUpdated');
    }
    sessionStorage.setItem(this.sessionDateKey, todayStr);

    const storedSessionStartTime = Number(sessionStorage.getItem(this.loginTimeSessionStartKey));
    const storedInitialHours = Number(sessionStorage.getItem(this.loginTimeInitialHoursKey));

    if (storedSessionStartTime > 0) {
      this.sessionStartTime = storedSessionStartTime;
    } else {
      this.sessionStartTime = Date.now();
      sessionStorage.setItem(this.loginTimeSessionStartKey, String(this.sessionStartTime));
    }

    if (!Number.isNaN(storedInitialHours) && storedInitialHours > 0) {
      this.initialTodaysTotalHoursLoggedIn = storedInitialHours;
    } else {
      this.initialTodaysTotalHoursLoggedIn = userData?.todaysTotalHoursLoggedIn ?? 0;
      sessionStorage.setItem(this.loginTimeInitialHoursKey, String(this.initialTodaysTotalHoursLoggedIn));
    }
  }

  private formatTodaysTotalHoursLoggedIn(): string {
    try {
      const elapsedMs = Math.max(
        0,
        Date.now() - this.sessionStartTime - this.excludedProductionTimeMs - this.getCurrentExcludedProductionTimeMs()
      );
      const elapsedHours = elapsedMs / (1000 * 60 * 60);

      const totalHours = this.initialTodaysTotalHoursLoggedIn + elapsedHours;
      const hours = Math.floor(totalHours);
      const minutes = Math.round((totalHours - hours) * 60);

      // Format the time
      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      } else {
        return `${minutes}m`;
      }
    } catch (error) {
      console.error('Error formatting total logged hours:', error);
      return '';
    }
  }

  private updateProductionTimeExclusion(): void {
    const isScanPullScreen = this.activeCategoryTab === 'Scan Pulls';

    if (isScanPullScreen && this.excludedProductionTimeStart === null) {
      this.excludedProductionTimeStart = Date.now();
    }

    if (!isScanPullScreen && this.excludedProductionTimeStart !== null) {
      this.excludedProductionTimeMs += Date.now() - this.excludedProductionTimeStart;
      this.excludedProductionTimeStart = null;
    }

    this.updateLoginTime();
  }

  private getCurrentExcludedProductionTimeMs(): number {
    if (this.excludedProductionTimeStart === null) {
      return 0;
    }

    return Date.now() - this.excludedProductionTimeStart;
  }

  // Scan production bin
  searchProductionBins() {
    const term = this.scanProductionBinTerm?.trim();
    if (!term) {
      this.toastr.error('Please scan or enter a production bin');
      return;
    }
    this.isScanningProductionBin = true;
    this.scanSearchAttempted = true;
    this.scanProductionBinResults = [];
    this.containersService
      .getAllContainers(
        this.companyId,
        this.tempSelectedStore,
        ContainerStatus.Available,
        ContainerType.Production,
        term
      )
      .subscribe({
        next: res => {
          const response = res as containerResponse | containerResponse[];
          this.scanProductionBinResults = Array.isArray(response) ? response : [response];
          if (this.scanProductionBinResults.length === 0) {
            this.toastr.error('No production bin found');
          }
          this.isScanningProductionBin = false;
        },
        error: err => {
          this.toastr.error('No production bin found');
          this.isScanningProductionBin = false;
        }
      });
  }

  resetScanProductionBinModal() {
    this.scanProductionBinTerm = '';
    this.scanProductionBinResults = [];
    this.scanSearchAttempted = false;
    this.isScanningProductionBin = false;
  }

  assignScannedProductionBin(bin: containerResponse) {
    this.sourceBinName = bin.description;
    localStorage.setItem('ProductionBin', bin.description);
    localStorage.setItem('ProductionBinId', JSON.stringify(bin.id));
    this.toastr.success('Production bin assigned successfully');
    this.resetScanProductionBinModal();
    this.containersService.updateContainerStatus(bin.id, ContainerStatus.InUse).subscribe({
      next: () => {
        this.toastr.success('Production bin status updated to In Use');
      },
      error: () => {
        this.toastr.error('Failed to update production bin status');
      }
    });
  }
  getScanProductionBinLabel(bin: containerResponse): string {
    return bin.referenceNumber || bin.description || `#${bin.id}||${bin.externalId}`;
  }
  unAssignProductionBin() {
    const id = parseInt(localStorage.getItem('ProductionBinId') || '0', 10);
    localStorage.removeItem('ProductionBin');
    localStorage.removeItem('ProductionBinId');
    this.sourceBinName = '';
    this.containersService.updateContainerStatus(id, ContainerStatus.Available).subscribe({
      next: () => {
        this.toastr.success('Production bin status updated to Available');
      },
      error: () => {
        this.toastr.error('Failed to update production bin status');
      }
    });
    this.toastr.success('Production bin unassigned successfully');
  }

  checkAndShowLPModal() {
    this.userService.getUserRolesandPerm().then((permissions) => {
      this.isLPScanRequired = permissions.some(p => p.name === 'RequireLPScan:View');
      const hasLP = !!this.overrideDetails?.licensePlateId;
      if (this.isLPScanRequired && !hasLP) {
        setTimeout(() => this.showModalSafely('scanLicensePlateModal'), 500);
      }
    });
  }

  private hideModalSafely(id: string) {
    if (id === 'scanLicensePlateModal' && this.scanLPModalInstance) this.scanLPModalInstance.hide();
    if (id === 'lpRequiredConfirmModal' && this.confirmModalInstance) this.confirmModalInstance.hide();
  }

  closeProfileDropdown() {
    document.querySelector('.admin-menu.show')?.classList.remove('show');
    const toggle = document.getElementById('dropdownMenuButton2');
    toggle?.classList.remove('show');
    toggle?.setAttribute('aria-expanded', 'false');
  }

  private showModalSafely(id: string) {
    this.closeProfileDropdown();
    const modalEl = document.getElementById(id);
    if (modalEl && typeof bootstrap !== 'undefined') {
      const modal = new bootstrap.Modal(modalEl, { backdrop: 'static', keyboard: false });
      if (id === 'scanLicensePlateModal') this.scanLPModalInstance = modal;
      if (id === 'lpRequiredConfirmModal') this.confirmModalInstance = modal;
      modal.show();
    }
  }

  handleLPModalCloseClick() {
    if (this.isLPScanRequired && !(this.isOverride && this.overrideDetails?.licensePlateId)) {
      this.hideModalSafely('scanLicensePlateModal');
      this.showModalSafely('lpRequiredConfirmModal');
    } else this.resetScanLicensePlateModal();
  }

  goBackToLPScan() {
    this.hideModalSafely('lpRequiredConfirmModal');
    this.showModalSafely('scanLicensePlateModal');
  }

  confirmLogout() {
    this.hideModalSafely('lpRequiredConfirmModal');
    this.Logout();
  }
}
